import { Grid } from '@mui/material';
import { StateButton } from '@tassat/button';
import { Field } from 'formik';
import * as React from 'react';

import { UserRoleFieldProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

export default function UserRoleField(props: UserRoleFieldProps) {
    const {
        name,
        label,
        allowedRoles,
        errors
    } = props;

    const classes = muiStyles(props);

    return (
        <Field
            name={name}
        >
            {({ field, form }) => (
                <div className={classes.field}>
                    <label
                        className={classes.inputLabel}
                        htmlFor={name}
                    >
                        {label}
                    </label>
                    <Grid
                        alignItems='center'
                        className={classes.clientRoleButtonsContainer}
                        container
                        direction='row'
                        justifyContent='flex-start'
                        spacing={0}
                        wrap='nowrap'
                    >
                        {allowedRoles.map((role) => (
                            <StateButton
                                className={classes.clientRoleField}
                                handleClick={() => {
                                    form.setFieldValue(name, role.value);
                                    form.setFieldTouched(name, true);
                                }}
                                key={role.label}
                                state={field.value === role.value ? 'active' : 'inactive'}
                                text={role.label.toString()}
                            />
                        ))}
                    </Grid>
                    <ErrorMessage
                        error={errors[name]}
                        field={field}
                        form={form}
                    />
                </div>
            )}
        </Field>
    );
}